export enum FeatureType {
  LESSON_PLANNER = 'LESSON_PLANNER',
  CATCH_UP_FRIDAYS = 'CATCH_UP_FRIDAYS',
}
